import { render, staticRenderFns } from "./FightNotif.vue?vue&type=template&id=6a39625a&"
import script from "./FightNotif.vue?vue&type=script&lang=js&"
export * from "./FightNotif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports